// src/utils/jwtDecoder.ts

interface DecodedJWT {
  [key: string]: any; // Allows any additional properties
  exp?: number; // 'exp' is optional and is a number (Unix timestamp)
  expDate?: Date; // 'expDate' is also optional and is a JavaScript Date object
}

export function decodeJWT(token: string): DecodedJWT | null {
  const parts = token.split('.');
  if (parts.length !== 3) {
    console.error('Invalid JWT: Must consist of header, payload, and signature parts');
    return null;
  }

  const base64Url = parts[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );

  const decoded: DecodedJWT = JSON.parse(jsonPayload);

  // Convert the 'exp' Unix timestamp to a JavaScript Date object
  if (decoded.exp) {
    decoded.expDate = new Date(decoded.exp * 1000); // JS uses milliseconds
  }

  return decoded;
}
